import styled from "styled-components";
import ArrowBackIosIcon from "@material-ui/icons/ArrowBackIos";

export const Text = styled.div`
  line-height: 30px;
`;

export const BackIcon = styled(ArrowBackIosIcon)`
  font-size: 16px;
  margin-top: 3px;
`;

export const BackContainer = styled.div`
  display: flex;
  flex-direction: row;
  color: white;
  padding: 4px 15px;
  font-weight: bold;
  background: #346c84;
  border-bottom-right-radius: 20px;
  border-top-right-radius: 20px;
  
  :hover {
		transform: scale(1.01);
		opacity: 0.9;
	}
	transition: 200ms ease;
`;
